module.exports = __webpack_public_path__ + "static/media/sad-tear.765ed6b2.svg";